/*eslint-disable*/
import React, { useState, useEffect } from "react";
import {
  TextField,
  Typography,
  Divider,
  Paper,
  Grid,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import { STYLES } from "config";

function TenantDetailsComponent({ data = {}, setvalue }) {
  const [state, setstate] = useState({
    tenant: {
      name: "",
      tenantTitle: "",
      surname: "",
      tenantHomeTel: "",
      tenantWorkTel: "",
      cellNumber: "",
      faxAddress: "",
      emailAddress: "",
      tenantLeaseEnds: "",
      tenantNoticePeriod: "",
      rentalPrice: "",
      tenantNotes: ""
    },
    ...data
  });

  useEffect(() => {
    if (data) setstate({ ...state, ...data });
  }, [data]);

  const updateDataNested = (e) => {
    const { name, value } = e.target;

    if (name === "fullName") {
      const [Name, ...lastNameParts] = value.split(" ");
      const lastName = lastNameParts.join(" ");

      const updatedState = {
        ...state,
        userdetials: {
          ...state.userdetials,
          Name: Name || "",
          lastName: lastName || ""
        }
      };

      setstate(updatedState);
      setvalue(updatedState);
    } else {
      const keys = name.split(".");
      const updatedState = { ...state };
      let current = updatedState;
      for (let i = 0; i < keys.length - 1; i++) {
        current = current[keys[i]] = current[keys[i]] || {};
      }
      current[keys[keys.length - 1]] = value;
      setstate(updatedState);
      setvalue(updatedState);
    }
  };

  return (
     <Paper elevation={5} sx={{ p: 3 }}>
    <Box sx={{ p: 2 }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 400,
          mb: 1,
          color: STYLES.WEB_APP_FONT_CLR
        }}
      >
        Tenant Details
      </Typography>

      <Divider sx={{ borderColor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

      <Paper elevation={0} sx={{ p: 2, mb: 2 }}>
        <Typography variant="body1">
          The Details of the tenant will be displayed on the website.
        </Typography>
      </Paper>

      <Divider sx={{ borderColor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Tenant Title:
          </Typography>
        </Grid>
        <Grid item size={10}>
          <FormControl fullWidth size="small">
            <Select
              name="tenant.tenantTitle"
              value={state.tenant?.tenantTitle || ""}
              onChange={updateDataNested}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiSelect-select": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
            >
              <MenuItem value="Mr">Mr</MenuItem>
              <MenuItem value="Ms">Ms</MenuItem>
              <MenuItem value="Mrs">Mrs</MenuItem>
              <MenuItem value="Dr">Dr</MenuItem>
              <MenuItem value="Prof">Prof</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Name:
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="tenant.name"
            size="small"
            value={state.tenant?.name || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Surname:
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="tenant.surname"
            size="small"
            value={state.tenant?.surname || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Home Tel:
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="tenant.tenantHomeTel"
            size="small"
            type="number"
            value={state.tenant?.tenantHomeTel || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Work Tel:
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="tenant.tenantWorkTel"
            size="small"
            type="number"
            value={state.tenant?.tenantWorkTel || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Cell:
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="tenant.cellNumber"
            size="small"
            type="number"
            value={state.tenant?.cellNumber || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Fax:
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="tenant.faxAddress"
            size="small"
            type="number"
            value={state.tenant?.faxAddress || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Email:
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="tenant.emailAddress"
            size="small"
            type="email"
            value={state.tenant?.emailAddress || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Tenant Lease Ends:
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="tenant.tenantLeaseEnds"
            size="small"
            multiline
            rows={3}
            value={state.tenant?.tenantLeaseEnds || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Tenant Notice Period:
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="tenant.tenantNoticePeriod"
            size="small"
            value={state.tenant?.tenantNoticePeriod || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Rental Price:
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="tenant.rentalPrice"
            size="small"
            multiline
            rows={3}
            value={state.tenant?.rentalPrice || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>

        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              mt: 1.5,
              color: STYLES.WEB_APP_FONT_CLR
            }}
          >
            Tenant Notes:
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            name="tenant.tenantNotes"
            size="small"
            multiline
            rows={4}
            value={state.tenant?.tenantNotes || ""}
            onChange={updateDataNested}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#003366"
                }
              },
              "& .MuiInputBase-input": {
                color: STYLES.WEB_APP_FONT_CLR
              }
            }}
          />
        </Grid>
      </Grid>
    </Box>
    </Paper>
  );
}

export default TenantDetailsComponent;
